import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import {
  MitsFormDateControlValueAccessorDirective
} from './mits-form-date-control-value-accessor.directive';
import { MitsFormDateComponent } from './mits-form-date.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule
  ],
  declarations: [
    MitsFormDateComponent,
    MitsFormDateControlValueAccessorDirective
  ],
  exports: [
    MitsFormDateComponent,
    MitsFormDateControlValueAccessorDirective
  ],
})
export class MitsFormDateModule {
}